import { FormControl } from "@gluestack-ui/themed";

import { Input } from "./components/Input";

import { InputHelperText } from "./components/InputHelperText";
import { InputError } from "./components/InputError";
import { InputLabel } from "./components/InputLabel";
import { IInputOTPProps } from "./types";
import { useInputOTPController } from "./useInputOTPController";

export const InputOTP = ({
  label,
  isLoading,
  placeholder = "0",
  numInputs = 6,
  helperText,
  inputType,
  errorMessage,
  value,
  onChange,
  isDisabled,
  isInvalid,
  isReadOnly,
  isRequired
}: IInputOTPProps) => {
  const { handleOnChangeInput, inputValue } = useInputOTPController({
    value,
    onChange
  });
  return (
    <FormControl
      size="md"
      $required-bgColor="blue"
      isDisabled={isDisabled || isLoading}
      isInvalid={isInvalid || !!errorMessage}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
    >
      <InputLabel label={label} />
      <Input
        value={inputValue}
        onChange={handleOnChangeInput}
        placeholder={placeholder}
        numInputs={numInputs}
        inputType={inputType}
      />

      <InputHelperText text={helperText} hasError={!!errorMessage} />
      <InputError errorMessage={errorMessage} />
    </FormControl>
  );
};
